
import { api } from '../lib/api-client.js';

import type { Org } from './org.js';
import type { CurrentUser } from '@sitewise/shared';

export async function listOrgs(): Promise<{ orgs: Org[] }> {
  return api<{ orgs: Org[] }>('/admin/orgs');
}

export async function getOrg(id: string): Promise<{ org: Org; users: CurrentUser[] }> {
  return api<{ org: Org; users: CurrentUser[] }>(`/admin/orgs/${id}`);
}

export async function createOrg(input: {
  slug: string;
  name: string;
  initialAdminEmail: string;
  initialAdminName: string;
}): Promise<{ org: Org; admin: CurrentUser }> {
  return api<{ org: Org; admin: CurrentUser }>('/admin/orgs', {
    method: 'POST',
    body: input,
  });
}

export interface ViewAsResponse {
  handoffToken: string;
  handoffExpiresAt: string;
  orgSlug: string;
}

export async function viewAsOrg(id: string): Promise<ViewAsResponse> {
  return api<ViewAsResponse>(`/admin/orgs/${id}/view-as`, { method: 'POST' });
}

export interface AuditLogEntry {
  id: string;
  orgId: string | null;
  actorUserId: string | null;
  actorKind: string;
  action: string;
  entityType: string | null;
  entityId: string | null;
  metadata: Record<string, unknown> | null;
  ip: string | null;
  userAgent: string | null;
  createdAt: string;
}

export async function listAuditLog(params?: {
  orgId?: string;
  actorUserId?: string;
  action?: string;
  entityType?: string;
  cursor?: string;
  limit?: number;
}): Promise<{ items: AuditLogEntry[]; nextCursor: string | null }> {
  const search = new URLSearchParams();
  if (params?.orgId) search.set('orgId', params.orgId);
  if (params?.actorUserId) search.set('actorUserId', params.actorUserId);
  if (params?.action) search.set('action', params.action);
  if (params?.entityType) search.set('entityType', params.entityType);
  if (params?.cursor) search.set('cursor', params.cursor);
  if (params?.limit) search.set('limit', String(params.limit));
  const qs = search.toString();
  return api<{ items: AuditLogEntry[]; nextCursor: string | null }>(
    `/admin/audit${qs ? `?${qs}` : ''}`,
  );
}
